import ListingVM from './listing-vm';
export default { 
  init: function(node){
    var master_records_data = JSON.parse($('#master_records_json').val());
    ko.applyBindingsWithValidation(new ListingVM(master_records_data), node, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS );
  }
};
